import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const getBaseUrl = () => {
  if (!API_BASE_URL) {
    throw new Error('API base URL is not configured. Please set REACT_APP_API_BASE_URL.');
  }
  return API_BASE_URL.endsWith('/') ? API_BASE_URL.slice(0, -1) : API_BASE_URL;
};

const levelService = {
  async getLevels(params = {}) {
    const base = getBaseUrl();
    const queryParams = new URLSearchParams();
    
    if (params.benefitType) queryParams.append('benefitType', params.benefitType);
    if (params.page !== undefined) queryParams.append('page', params.page + 1); // MUI uses 0-based page
    if (params.limit) queryParams.append('limit', params.limit);
    if (params.search) queryParams.append('search', params.search);
    if (params.status) queryParams.append('status', params.status);

    const url = `${base}/api/levels?${queryParams.toString()}`;
    const response = await axios.get(url);
    return response.data;
  },

  async updateLevel(id, payload) {
    const base = getBaseUrl();
    const response = await axios.put(`${base}/api/levels/${id}`, payload);
    return response.data;
  },

  async createLevel(payload) {
    const base = getBaseUrl();
    const response = await axios.post(`${base}/api/levels`, payload);
    return response.data;
  },

  async deleteLevel(id) {
    const base = getBaseUrl();
    const response = await axios.delete(`${base}/api/levels/${id}`);
    return response.data;
  }
};

export default levelService;
